import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { IChip } from '../_shared/models/chip.model';
import { IChips } from '../_shared/models/chips.model';
import { ChipSize } from '../_shared/types/chip-size.type';
import { ChipAttention, ChipType } from '../_shared/types/chip.type';
import { ChipComponent } from './chip.component';

@Component({
    selector: 'sirius-chips',
    template: `
        <ul [attr.aria-label]="resolvedAriaLabel()">
            @for (chip of resolvedChips(); track trackChip($index, chip)) {
                <li>
                    <sirius-chip
                        [config]="chip"
                        [type]="resolvedType()"
                        [attention]="resolvedAttention()"
                        [size]="resolvedSize()"
                    ></sirius-chip>
                </li>
            }
        </ul>
    `,
    styleUrls: ['./chips.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ChipComponent],
    host: {
        'class': 'sir-chips',
    },
})
export class ChipsComponent {
    readonly config = input<IChips | undefined>();
    readonly chips = input<readonly IChip[]>([]);
    readonly type = input<ChipType>('solid');
    readonly attention = input<ChipAttention>('high');
    readonly size = input<ChipSize>('s');
    readonly ariaLabel = input('Chips');

    readonly resolvedChips = computed<readonly IChip[]>(() => this.config()?.chips ?? this.chips());
    readonly resolvedType = computed<ChipType>(() => this.config()?.type ?? this.type());
    readonly resolvedAttention = computed<ChipAttention>(() => this.config()?.attention ?? this.attention());
    readonly resolvedSize = computed<ChipSize>(() => this.config()?.size ?? this.size());
    readonly resolvedAriaLabel = computed(() => this.config()?.ariaLabel ?? this.ariaLabel());

    trackChip(index: number, chip: IChip): string {
        return `${chip.text}-${index}`;
    }
}
